// Success
export const FIRST_NAME_UPDATED = 'First name updated successfuly!'
export const LAST_NAME_UPDATED = 'Last name updated successfuly!'
export const EMAIL_ADDRESS_UPDATED = 'Email address updated successfuly!'
export const PASSWORD_UPDATED = 'Password updated successfuly!'

// Error
export const INVALID_PASSWORD = 'You have entered an invalid password'
export const UNFINISHED_DIALOG = "You didn't finished filling form. Changes will not be done!"
export const PROJECT_CODE_ALREADY_EXISTS = 'This project code already exist in database!'
export const EMPTY_FIELD = 'Field is empty'
